import { __extends } from "tslib";
import { Event } from './Event';
import { axCoerceString } from '@awayjs/graphics';
var StageVideoAvailabilityEvent = /** @class */ (function (_super) {
    __extends(StageVideoAvailabilityEvent, _super);
    function StageVideoAvailabilityEvent(type, bubbles, cancelable, availability) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (availability === void 0) { availability = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.availability = axCoerceString(availability);
        return _this;
    }
    StageVideoAvailabilityEvent.classInitializer = null;
    StageVideoAvailabilityEvent.classSymbols = null;
    StageVideoAvailabilityEvent.instanceSymbols = null;
    // JS -> AS Bindings
    StageVideoAvailabilityEvent.STAGE_VIDEO_AVAILABILITY = 'stageVideoAvailability';
    return StageVideoAvailabilityEvent;
}(Event));
export { StageVideoAvailabilityEvent };
